import { AUTH_TOKEN, TOKEN_EXPIRATIONS } from 'constants/auth';
import { destroyCookie, parseCookies, setCookie } from 'nookies';

export const tokenExists = (tokenKey: AUTH_TOKEN, ctx: any = null) => {
  const cookies = parseCookies(ctx);
  const authToken = cookies[tokenKey];
  return typeof authToken === 'string';
};

export const getToken = (tokenKey: AUTH_TOKEN, ctx: any = null) =>
  getCookie(tokenKey, ctx);

export const getCookie = (cookieKey: string, ctx: any = null) => {
  const cookies = parseCookies(ctx);
  const value = cookies[cookieKey];
  return value;
};

export const setAuthToken = (idToken: string, refreshToken: string) => {
  setToken(AUTH_TOKEN.ACCESS, idToken);
  setToken(AUTH_TOKEN.REFRESH, refreshToken);
};

export const setToken = (
  tokenKey: AUTH_TOKEN,
  tokenValue: string,
  ctx: any = null,
  domain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN
) => {
  setCookie(ctx, tokenKey, tokenValue, {
    maxAge: TOKEN_EXPIRATIONS[tokenKey],
    path: '/',
    domain,
  });
};

export const destroyToken = (tokenKey: AUTH_TOKEN, ctx?: any) => {
  destroyCookie(ctx, tokenKey);
};

export const clearBrowserAuth = () => {
  Object.values(AUTH_TOKEN).forEach((tokenKey) => {
    destroyCookie(null, tokenKey, {
      path: '/',
      domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
    });
  });
  if (window.localStorage) {
    window.localStorage.clear();
  }
};

export const standardizeErrorMessage = (errorMessage: string): string => {
  if (errorMessage.includes('There is already an existing user')) {
    return 'There is already a user with that email';
  }

  return typeof errorMessage === 'string'
    ? errorMessage
    : 'Issue authenticating';
};
